import type { ReactNode } from 'react'

import { AUTH_FOOTER_LINK_LIST } from './auth-footer-links.const'

export const AuthFooterLinks: React.FC = (): ReactNode => (
  <nav className="auth-footer-links flex items-center justify-center gap-4 py-4">
    {AUTH_FOOTER_LINK_LIST.map((link) => (
      <a
        key={link.href}
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-muted-foreground underline transition-colors hover:text-foreground"
      >
        {link.label}
      </a>
    ))}
  </nav>
)
